const colors = {
  lightMainColor: '#05bfdb',
  mainColor: '#0883a3',
  darkMainColor: '#0a4d68',
  lightGray: '#DFDFDF',
  middleGray: '#9B9B9B',
  darkGray: '#8C8C8C',
  red: '#d40000',
  green: '#00a341',
  yellow: '#fccc3d',
  blue: '#053c74',
  black: '#353535',
};

export default colors;
